export default {
    root: ({ context }) => ({
        class: [
            // Font
            // 'leading-6',
            'text-gray-800',
            'font-semibold',
            // Display
            'flex',
            'flex-row-reverse',
            'gap-x-2',
            'items-center',
            'justify-end',
            // Spacing
            'p-4',
            // Color
            'bg-white',
            'border-gray-200',
            'hover:bg-gray-100',
            'border',
            // 'transition duration-200 ease-in-out',
            'focus-visible:outline-none focus-visible:border-gray-200 focus-visible:ring-0'
            // {
            //     'focus-visible:outline-none focus-visible:border-gray-200 focus-visible:ring-0': !context.disabled
            // }
        ]
    }),
    toggleIcon: 'text-gray-800'
};
